<ng-template #noCasesChannels>
  <h5 class="border-top border-1 pt-3">No channels selected.</h5>
</ng-template>

<admin-panel-empty *ngIf="result.length > 0; else noCasesChannels">
  <admin-table-collapsable [items]="result" [colspan]="'10'" [custom]="['standard-table', 'fs-5']">
    <ng-template #header>
      <th style="width: 7%" ngbSortableHeader sortable="risk" (sort)="onSort($event)">Risk</th>
      <th style="width: 7%" ngbSortableHeader sortable="status" (sort)="onSort($event)">Status</th>
      <th style="width: 12%" ngbSortableHeader sortable="internal" (sort)="onSort($event)">Case</th>
      <th style="width: 10%" ngbSortableHeader sortable="batch" (sort)="onSort($event)">Batch</th>
      <th style="width: 15%">Channel</th>
      <th style="width: 15%" ngbSortableHeader sortable="record" (sort)="onSort($event)">Record</th>
      <th style="width: 10%" ngbSortableHeader sortable="data" (sort)="onSort($event)">Data</th>
      <th style="width: 13%" ngbSortableHeader sortable="created" (sort)="onSort($event)">Created</th>
      <th style="width: 6%" ngbSortableHeader sortable="result" (sort)="onSort($event)">Score</th>
      <th style="width: 6%">&nbsp;</th>
    </ng-template>
    <ng-template #first let-item let-index="index" let-refid="refid">
      <td><div class="text-uppercase"><span [ngClass]="'risk-badge-' + riskClass(item.risk)" class="badge">{{('pages.lookup.single.result.alert_risk.' + item.risk | translate)}}</span></div></td>
      <td><div class="text-uppercase"><span [ngClass]="'status-text-' + statusClass(item.status)" class="fs-5 fw-bolder status-badge">{{ item.status }}</span></div></td>
      <td>
        <button [routerLink]="['/admin/results/case/view', item.internal]" type="button" class="btn text-action-2 fs-5 text-info p-0">
          {{ item.internal }}
        </button>
      </td>
      <td>{{ item.batch }}</td>
      <td>{{ item.channel.owner }} / {{ item.channel.vertical }} / {{ item.channel.code }}</td>
      <td>{{ item.entry.record }}</td>
      <td>{{ item.data }}</td>
      <td>{{ item.created | date:'short' }}</td>
      <td><span class="fw-bolder" [ngClass]="'risk-text-' + riskClass(item.risk)">{{item.result?.toFixed(1)}}</span></td>
      <td class="justify-content-around text-end ps-0 pe-0 weight-label">
        <a class="text-decoration-none text-purple action-buttons" data-bs-toggle="collapse" [attr.data-bs-target]="'#item' + refid + index" role="button">
          <i class="bi bi-info-square"></i>&nbsp;info
        </a>
      </td>
    </ng-template>
    <ng-template #second let-item>
      <admin-panel-confirm [title]="'reporting reasons'">
        <table class="table table-responsive align-middle inner-table w-100 m-0">
          <tbody class="table-group-divider">
          <tr *ngFor="let rr of item.reasons">
            <td style="width: 10%"><span [ngClass]="'text-uppercase fw-bolder risk-text-' + riskClass(rr.risk!)">{{('pages.lookup.result.risk.' + rr.risk | translate)}}</span></td>
            <td style="width: 90%" class="text-dark">{{ rr.reason }}</td>
          </tr>
          </tbody>
        </table>
      </admin-panel-confirm>
    </ng-template>
  </admin-table-collapsable>
  <div class="row d-flex justify-content-center p-2" *ngIf="all.length >= pageSize">
    <ngb-pagination class=""
      [collectionSize]="all.length"
      [(page)]="page"
      [pageSize]="pageSize"
      (pageChange)="paginate()"
    >
    </ngb-pagination>
  </div>
</admin-panel-empty>
